import { createIndicator } from "@nexus/widget-kit";

/**
 * Live indicator: the shared metric indicator on the `live-kpi-metrics` source only, so an
 * author picks a metric of this domain and never a source.
 */
const indicator = createIndicator({
  id: "live-kpi-indicator",
  name: "Live indicator",
  description:
    "One or two live figures — detections, responses, anomalies — over the dashboard's time range.",
  source: "live-kpi-metrics",
  sources: ["live-kpi-metrics"],
});

export const { manifest, Component, defaultConfig, settings } = indicator;
export default indicator;
